import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { gettingStartedEntryPoint } from '@jira/spa-apps__servicedesk-getting-started-page/src/gettingStartedEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { servicedeskPortalGroupsResource } from '@jira/router-resources__service-desk-portal-groups/src/servicedeskPortalGroupsResource.tsx';
import { servicedeskGettingStartedRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { GettingStartedPageSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/GettingStartedPageSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const gettingStartedPageEntryPoint = createPageEntryPoint({
	main: gettingStartedEntryPoint,
});

export const servicedeskGettingStartedRouteEntry: Route = createEntry(
	servicedeskGettingStartedRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-getting-started-page-load',
		skeleton: GettingStartedPageSkeleton,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
			servicedeskIssueTypesResource,
			servicedeskPortalGroupsResource,
		],

		entryPoint() {
			return fg('gsp_production_rollout') ? gettingStartedPageEntryPoint : undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
